import React from 'react';
import { withTranslation } from 'react-i18next';
import { MyInput } from '../../../../Base/Form';
const GeneratorInput = (props) => {
    const { text, onChange, placeholder, placeholderParams, additionalStyles, disabled, t, options } = props;
    return (React.createElement(MyInput, Object.assign({ placeholder: placeholder ? t(`${placeholder}`, placeholderParams) : null, value: text, onChangeHandler: onChange, className: additionalStyles, disabled: disabled, size: "large" }, options)));
};
export default withTranslation()(GeneratorInput);
